import { Button } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../../../core/common/dataTable/index";
import { getLeaveTypes } from "../../../../core/data/redux/leaveSlice";
import { DateFormat } from "../../../../core/hooks/dateFormat";
import { all_routes } from "../../../router/all_routes";
import PermissionGuard from "../../../permissionGuard";

const LeaveType = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const leaveState = useSelector((state: any) => state.leavesState);

  const [dataList, setDataList] = useState<any[]>([]);
  const [query, setQuery] = useState<string>("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });

  const fetchRecords = (pagination: any, query: string) => {
    dispatch(
      getLeaveTypes({
        page: pagination.current,
        limit: pagination.pageSize,
        query,
      })
    );
  };

  const handlePagination = (pagination: any) => {
    setPagination({
      current: pagination.page,
      pageSize: pagination.pageSize,
      total: pagination.total || 10,
    });
    fetchRecords(pagination, query);
  };

  const handleSearch = (query: string) => {
    fetchRecords(pagination, query);
  };

  useEffect(() => {
    fetchRecords(pagination, query);
  }, []);

  useEffect(() => {
    if (leaveState.loading === "fulfilled") {
      setDataList(leaveState.leaveTypes?.data?.data || []);
      setPagination((prev) => ({
        ...prev,
        total: leaveState.leaveTypes?.total || 0,
        current: leaveState.leaveTypes?.currentPage || 1,
        pageSize: leaveState.leaveTypes?.limit || 10,
      }));
    }
  }, [leaveState.loaading]);

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      width: 100,
      render: (text: string, record: any, index: number) => (
        <>
          <div>
            {pagination.current
              ? index +
              pagination.current * pagination.pageSize -
              pagination.pageSize +
              1
              : index + 1}
          </div>
        </>
      ),
      //sorter: (a: any, b: any) => a.id.length - b.id.length,
    },
    {
      title: "Leave Type",
      dataIndex: "leaveTypes",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Description",
      dataIndex: "description",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      render: (created_at: any) => DateFormat(created_at) || "",
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      render: (created_at: any) => DateFormat(created_at) || "",
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Leave Types</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Settings</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Leave Types
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <PermissionGuard route="leave-type/add">
              <Button
                type="primary"
                //   onClick={handleAdd}
                className="d-flex align-items-center mb-2"
                style={{ backgroundColor: "red" }}
              >
                <i className="ti ti-square-rounded-plus me-2" />
                Add Leave Type
              </Button>
            </PermissionGuard>
          </div>
        </div>
        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
            <h4 className="mb-4 mt-3">Leave Types List</h4>
          </div>
          {/* <pre>{JSON.stringify(dataList, null, 2)}</pre> */}
          <div className="card-body p-0 py-3">
            <Table
              columns={columns}
              dataSource={dataList}
              Selection={false}
              paginationConfig={pagination}
              handlePagination={handlePagination}
              loading={leaveState.loading === "pending"}
              handleSearch={handleSearch}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaveType;
